export class SalesOfficeType {
    ID: number;
    Name: string;
}

export default SalesOfficeType;